import styled from 'foundations-theming/utils';
const Whitespace = styled.div.withConfig({
  displayName: "Whitespace",
  componentId: "ry0w5l-0"
})(["height:", "px;"], ({
  height
}) => height);
export default Whitespace;